// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3lno0","requiredAsterisk":"Info_requiredAsterisk__25K4s"};